export enum FeatureFlag {
  CollaborativeMaps = 'frontend-2022-collaborative-maps',
  AtInstallation = 'frontend-2022-at-installation',
  BuilderTableToQuery = 'frontend-2022-builder-table-to-query',
  BasemapSelectorInLegend = 'frontend-2023-new-basemap-selector-in-builder',
  NPSVitallySurvey = '2024-nps-with-vitally',
  WorkflowsScheduling = '2023-workflows-scheduling',
  WorkflowsDO = '2023-workflows-do',
  SqlParamsNumeric = '2023-sql-params-numeric',
  WorkflowsExport = '2023-workflows-export',
  WorkflowsExport2 = '2023-workflows-export-ii',
  WorkflowsImport = '2023-workflows-import',
  WorkflowsEnrichment = '2023-workflows-enrichment',
  WorkflowsGenAiDescription = '2023-workflows-gen-ai-description',
  WorkflowsDataExport = '2023-workflows-data-export',
  DatabricksConnectionEnabled = '2024-databricks-connection-enabled',
  WorkflowsRasterComponents = '2024-workflows-raster-components',
  ReduceNumberOfQueries = '2024-reduce-number-of-queries',
  DeprecateDateForTilesetFromDataExplorer = '2024-deprecate-create-tileset-from-dataexplorer-ui',
  WorkflowsPackageExtension = '2024-workflows-package-extension',
  QueryConcurrencyControl = '2024-query-concurrency-control',
  PrivateBuckets = '2024-private-buckets',
  TagsForResources = '2024-tags-for-resources',
  CatalogWorkflowTemplates = '2024-catalog-workflow-templates',
  DeliverRawAuditLogs = '2024-deliver-raw-audit-logs',
  H3PointsAggregation = '2024-point-h3-aggregation-in-builder',
  SuperadminMode = '2024-superadmin-mode',
  TableWidgetRevamp = '2024-table-widget-revamp',
  TableWidgetHighlightAndZoom = '2024-table-widget-highlight-and-zoom',
  SnowflakeRowLevelSecurity = '2024-snowflake-viewer-creds-row-level-security',
  OrganizationPalettes = '2024-organization-palettes',
  ForceLoginMethodEnabled = '2024-force-login-method',
  ListDoSubscriptions = '2024-list-do-subscriptions-settings',
  NamedSources = '2024-sql-named-sources-ui',
  GroupMembers = '2024-show-sso-group-members',
  SwapMapSource = '2024-swap-map-source',
  RastersInBuilder = '2024-rasters-in-builder',
  WorkloadIdentityFederation = '2024-workload-identity-federation-bigquery',
  DatabricksOAuth = '2025-oauth-authentication-for-databricks',
  DatabricksDeprecateVCPAT = '2025-deprecate-databricks-vc-pat',
  BuilderPopupAsync = '2024-builder-popup-async',
  AggregateByGeometry = '2024-aggregate-by-geometry-ui',
  KeyPairAuthForSnowflake = '2024-key-pair-authentication-for-snowflake',
  BuilderDocumentModeRemovalInMem = '2024-builder-document-mode-removal-in-mem',
  BuilderDocumentModeRemovalCommit = '2024-builder-document-mode-removal-commit',
  GuestMode = '2025-guest-users',
  WorkflowsBuilderMapComponent = '2025-workflows-builder-map-component',
  DataSourcesWithoutAssociatedLayers = '2025-data-sources-without-associated-layers',
  BuilderMapComments = '2025-builder-map-comments',
  CrossFilteringWidgets = '2025-cross-filtering-widgets',
  DeprecateSqlAnalysisInBuilder = '2025-deprecate-sql-analysis-in-builder',
  workflowsCollaborationMode = '2025-collaboration-mode-workflows',
  BuilderCustomAggregationPhase2 = '2025-builder-custom-aggregation-phase-2',
  BuilderRasterWidgets = '2025-builder-raster-widgets',
  WorkflowsControlComponents = '2025-workflows-control-components',
  GenAIV1 = '2025-genai-v1'
}

export type FeatureFlagSet = Record<FeatureFlag, boolean | string>
export type FeatureFlagOverrides = Partial<FeatureFlagSet>

export type DeepPartial<K> = {
  [attr in keyof K]?: K[attr] extends object
    ? DeepPartial<K[attr]>
    : K[attr] extends object | null
    ? DeepPartial<K[attr]> | null
    : K[attr] extends object | null | undefined
    ? DeepPartial<K[attr]> | null | undefined
    : K[attr]
}
